<div class="hbox-nowrap micro-radio">
  <micro-checkbox *ngFor="let option of options" [positive]="option.positive" [negative]="option.negative"
                  [(checked)]="option.checked" (checkedChange)="changed(option)" [radio]="true" [disabled]="option.checked">
  </micro-checkbox>
</div>
